import React from 'react'
import PropTypes from 'prop-types'
import { Card, Typography, Divider } from 'antd'
import { CrownOutlined } from '@ant-design/icons'
import { formatDateOnly } from 'src/Common/FormatDateTime'

const { Title, Text } = Typography

const CertificateOfCompletion = ({ certificate }) => {
  if (!certificate) return null

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        padding: '40px',
        background: '#f5f5f5',
        minHeight: '100vh',
      }}
    >
      <Card
        style={{
          width: '900px',
          border: '1px solid #d9d9d9',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          padding: 0,
          overflow: 'hidden',
        }}
        bordered={false}
      >
        {/* Header Section */}
        <div
          style={{
            background: '#001529',
            padding: '24px',
            textAlign: 'center',
            color: 'white',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <CrownOutlined style={{ fontSize: '32px', marginRight: '16px', color: '#faad14' }} />
            <Title level={3} style={{ color: 'white', margin: 0 }}>
              1 Journey.ai
            </Title>
          </div>
          <Text style={{ color: 'rgba(255, 255, 255, 0.65)' }}>Learning Management System</Text>
        </div>

        {/* Certificate Content */}
        <div
          style={{
            padding: '60px',
            textAlign: 'center',
            background: 'white',
          }}
        >
          <Text type="secondary" style={{ display: 'block', marginBottom: '8px' }}>
            This is to certify that
          </Text>

          <Title
            level={2}
            style={{
              marginBottom: '40px',
              fontWeight: 600,
              color: '#1d1d1d',
            }}
          >
            {certificate.firstName} {certificate.lastName}
          </Title>

          <Divider style={{ borderTop: '1px  #d9d9d9' }}>
            <Text strong style={{ fontSize: '18px' }}>
              has successfully completed
            </Text>
          </Divider>

          <Title
            level={3}
            style={{
              color: '#1890ff',
              margin: '40px 0 20px',
              fontWeight: 500,
            }}
          >
            {certificate.projectTitle}
          </Title>

          <div
            style={{
              marginBottom: '40px',
              padding: '16px',
              background: '#fafafa',
              borderLeft: '4px solid #1890ff',
              borderRight: '4px solid #1890ff',
            }}
          >
            <Text strong style={{ fontSize: '16px' }}>
              {' '}
              Completed on {formatDateOnly(certificate.createdOn)}
            </Text>
          </div>
        </div>
      </Card>
    </div>
  )
}

CertificateOfCompletion.propTypes = {
  certificate: PropTypes.shape({
    id: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    projectTitle: PropTypes.string,
    createdOn: PropTypes.string,
  }),
}

CertificateOfCompletion.defaultProps = {
  certificate: null,
}

export default CertificateOfCompletion
